import { lib } from 'crypto-js';

export function generateClasses<T extends string>(componentName: string, classes: T[]) {
  return classes.reduce(
    (acc, cls) => {
      acc[cls] = `Acadly${componentName}-${cls}`;
      return acc;
    },
    {} as Record<T, string>
  );
}

/**
 * Generates a random string of provided length
 * @param length length of string to be generated
 * @returns random string
 */
export function randomStr(length = 8) {
  return lib.WordArray.random(length).toString();
}

export function getAlphabetFromIndex(index: number) {
  if (index < 0 || index > 25) return '';
  return String.fromCharCode(64 + index + 1);
}

/**
 * Formats fractional numbers to fixed decimal places.
 * It does NOT formats integer numbers.
 * @param num number to be formatted
 * @param decimals fixed of decimals to show
 * @param suffix suffix to append in formatted number string
 * @returns formatted number string
 *
 * @example
 * formatFractions(4) // returns '4'
 * formatFractions(4.4445) // returns '4.44'
 * formatFractions(4.4555) // returns '4.46'
 * formatFractions(4.1) // returns '4.10'
 * formatFractions(4.1, '%') // returns '4.10%'
 */
export function formatFractions(num: number, suffix = '', decimals = 2) {
  const formattedNumber = Number.isInteger(num) ? num.toString() : num.toFixed(decimals);
  return formattedNumber + suffix;
}

export const allSettled = async <T>(promises: Promise<T>[]) =>
  Promise.all(
    promises.map((p) =>
      p
        .then(
          (value) =>
            ({
              status: 'fulfilled',
              value,
            }) as const
        )
        .catch(
          (reason) =>
            ({
              status: 'rejected',
              reason,
            }) as const
        )
    )
  );

const SHORT_ID_LENGTH = 8;

/**
 * Last 8 charcters of a mongodb id
 * @param id mongodb id
 */
export function toShortId(id: MongoId) {
  return id ? id.slice(-SHORT_ID_LENGTH) : '';
}
